export const SET_CURRENT_SONG = 'SET_CURRENT_SONG'
export const TOGGLE_RANDOM = 'TOGGLE_RANDOM'
export const TOGGLE_REPEAT = 'TOGGLE_OPTIONS'
export const TOGGLE_PLAYING = 'TOGGLE_PLAYING'

